import { Icon, LegacyStack, Tag } from '@shopify/polaris';
import { ProductsMinor } from '@shopify/polaris-icons';
import { useCurrency } from '../../../customHooks/useCurrency';
import { formatPvp } from '../../../helpers/productHelpers';

/**
 * Etiqueta de PVP de un producto. Sirve tanto para precio único como
 * para rango (min ≠ max), aplicando el tipo de cambio de la moneda
 * activa. Si el producto no tiene precio no pinta nada.
 *
 * Con un solo valor (`pvpMin`) se usa también para el PVP medio.
 */
const PvpTag = ({ pvpMin, pvpMax, label = 'PVP' }) => {
  const { currency } = useCurrency();
  const price = formatPvp(pvpMin, pvpMax, currency);
  if (!price) return null;

  return (
    <Tag>
      <LegacyStack spacing="extraTight">
        <Icon source={ProductsMinor} color="base" />
        <span>{`${label} ${price}`}</span>
      </LegacyStack>
    </Tag>
  );
};

export default PvpTag;
